export const blogsData=[
    {
        img:"https://miro.medium.com/max/1600/1*AoOWn4UdPyuixXtkLQsQXA.png",
        title:"Fun With Javascript Array",
        description:"When I think to add anything to an array then my memory reminds me of a childhood scene",
        technology:["React.js", "Node.js"],
        date:"25 August 2020",
        liveLink:"https://medium.com/@18103045tare",
        
    },
    {
        img:"https://previews.123rf.com/images/yacobchuk/yacobchuk1610/yacobchuk161000439/64097226-thinking-about-it-delighted-young-concentrated-programmer-working-on-a-laptop-and-coding-while-sitti.jpg",
        title:"Think anything like as Programmer",
        description:"Liam is a junior programmer. He always compares anything with programming and tries to do any task with a programming language",
        technology:["React.js", "Node.js"],
        date:"25 August 2020",
        liveLink:"https://medium.com/@18103045tare",

        
    },
    {
        img:"https://blog.jscrambler.com/content/images/2016/12/iot_js-min.png",
        title:"5 Basic Javascript things",
        description:"As a developer, you must mindset for a long journey and then you need to learn a lot of things and a lot of technologies day by day",
        technology:["React.js", "Node.js"],
        date:"25 August 2020",
        liveLink:"https://medium.com/@18103045tare",

        
    },
]